<template>
  <div :class="{ 'sidebar-municipalities-index': true }">
    <SidebarTopRightOrientation>
      <div class="sidebar-top-right-orientation__right">
        <button
          @click="closeSidebarMunicipalitiesIndex"
          class="sidebar-top-right-orientation__button"
        >
          <div class="sidebar-top-right-orientation__button__text">Sluit</div>
          <svg class="sidebar-top-right-orientation__button__icon" svg-inline="" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" transform="rotate(-45 12 12)" d="M11 4h2v16h-2z"/><path fill="#101010" mask="url(#b)" transform="rotate(45 12 12)" d="M11 4h2v16h-2z"/></g></svg>
        </button>
      </div>
    </SidebarTopRightOrientation>
    <div class="sidebar-municipalities-index__scrollable">
      <div class="sidebar-municipalities-index__middle">
        <SidebarTitleBar>
          <div
            class="sidebar-title-bar__icon-container"
            @click="closeSidebarMunicipalitiesIndex"
          >
            <svg svg-inline="" class="sidebar-title-bar__icon-container__icon" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" d="M16 4.462L14.603 3 6 12l8.603 9L16 19.538 8.795 12z"/></g></svg>
          </div>

          <div class="sidebar-title-bar__inner">
            <div class="sidebar-title-bar__inner__left">
              <div class="sidebar-title-bar__inner__left__title">
                Nieuwe locatie
              </div>
              <div class="sidebar-title-bar__inner__left__subtitle">
                Selecteer een gemeente
              </div>
            </div>
          </div>
        </SidebarTitleBar>

        <GpsSearch>
          <input
            class="gps-search__input-field"
            type="text"
            placeholder="Zoek een gemeente"
            v-model="municipalitySearchInput"
          />
          <svg svg-inline="" class="gps-search__search-icon" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="#101010" mask="url(#b)"/></g></svg>
          <div class="gps-search__input-small">
            Of klik op het GPS-icoontje om je eigen locatie te gebruiken
          </div>
          <template v-if="gpsLoading">
            <svg svg-inline="" class="gps-search__spinner-icon" focusable="false" role="presentation" aria-hidden="true" data-prefix="fas" data-icon="spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"/></svg>
          </template>
          <template v-else>
            <svg svg-inline="" class="gps-search__location-icon" @click="positionToMunicipality" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" fill="#101010" mask="url(#b)"/></g></svg>
          </template>
        </GpsSearch>

        <!-- <ul class="sidebar-municipalities-index__results">
          <li v-for="municipalityResult in municipalityResults" :key="municipalityResult.id" @click="setActiveMunicipality(municipalityResult)" class="col col--4">
            {{municipalityResult.name}}
          </li>
        </ul> -->
      </div>

      <div class="sidebar-municipalities-index__bottom-top">
        <div class="sidebar-municipalities-index__small-title">
          Deelnemende gemeentes
        </div>
      </div>

      <div class="sidebar-municipalities-index__bottom">
        <div class="row">
          <div
            v-for="availableMunicipality in filteredAvailableMunicipalities"
            :key="availableMunicipality.id"
            class="col col--4"
          >
            <div
              class="available-column"
              @click="setActiveMunicipality(availableMunicipality, false)"
            >
              <template v-if="availableMunicipality.app_asset">
                <img
                  class="available-column__image"
                  :src="availableMunicipality.app_asset.icon_url"
                />
              </template>
              <template v-else>
                <div class="available-column__fallback">
                  <div class="available-column__fallback__text">
                    {{ availableMunicipality.name.charAt(0) }}
                  </div>
                </div>
              </template>
              <div class="available-column__title">
                {{ availableMunicipality.name }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="sidebar-municipalities-index__down-top">
        <div class="sidebar-municipalities-index__small-title">
          Gemeentes die niet deelnemen
        </div>
      </div>

      <div class="sidebar-municipalities-index__down">
        <div
          v-for="unavailableMunicipality in filteredUnavailableMunicipalities"
          :key="unavailableMunicipality.id"
          class="unavailable-row"
        >
          <div class="unavailable-row__left">
            <div class="unavailable-row__title">
              {{ unavailableMunicipality.name }}
            </div>
          </div>
          <div class="unavailable-row__right">
            <div
              class="unavailable-row__button"
              @click="openModalNonParticipant(unavailableMunicipality)"
            >
              Uitnodigen
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-if="active">
      <portal to="page-shadow">
        <PageShadow />
      </portal>
    </template>

    <template v-if="modalNonParticipant">
      <ModalNonParticipant :selectedNonParticipant="selectedNonParticipant" />
    </template>

    <template v-if="modalNonParticipantTwo">
      <ModalNonParticipantTwo
        :selectedNonParticipant="selectedNonParticipantTwo"
      />
    </template>
  </div>
</template>

<script>
import PrivateApi from "@/services/PrivateApi.js";
import LoadOrReturnGemeentes from "@/services/LoadOrReturnGemeentes.js";
import ModalNonParticipant from "@/components/Home/ModalNonParticipant.vue";
import ModalNonParticipantTwo from "@/components/Home/ModalNonParticipantTwo.vue";
import PageShadow from "@/components/PageShadow.vue";
import SidebarTitleBar from "@/components/SidebarTitleBar.vue";
import SidebarTopRightOrientation from "@/components/SidebarTopRightOrientation.vue";
import GpsSearch from "@/components/GpsSearch.vue";
import gmapsInit from "@/utils/gmaps";

export default {
  components: {
    ModalNonParticipant,
    ModalNonParticipantTwo,
    PageShadow,
    SidebarTitleBar,
    SidebarTopRightOrientation,
    GpsSearch
  },
  data() {
    return {
      gpsLoading: false,
      availableMunicipalities: null,
      unavailableMunicipalities: null,
      municipalitySearchInput: null
    };
  },
  computed: {
    latitude() {
      return this.$store.state.ui.latitude;
    },
    longitude() {
      return this.$store.state.ui.longitude;
    },
    modalNonParticipant() {
      return this.$store.state.ui.modalNonParticipant;
    },
    selectedNonParticipant() {
      return this.$store.state.ui.selectedNonParticipant;
    },
    active() {
      return !this.modalNonParticipant || !this.modalNonParticipantTwo;
    },
    modalNonParticipantTwo() {
      return this.$store.state.ui.modalNonParticipantTwo;
    },
    selectedNonParticipantTwo() {
      return this.$store.state.ui.selectedNonParticipantTwo;
    },
    // municipalityResults() {
    //   let searchInput = this.municipalitySearchInput
    //   if (searchInput) {
    //     let re = new RegExp(searchInput, 'i');
    //     return this.availableMunicipalities.filter(x => x.name.match(re));
    //   }
    // },
    filteredAvailableMunicipalities() {
      let searchInput = this.municipalitySearchInput;
      if (searchInput && this.availableMunicipalities) {
        let filteredSearchInput = searchInput.replace(/[^a-zA-Z0-9 |_-]/g, "");
        let re = new RegExp(filteredSearchInput, "i");
        return this.availableMunicipalities.filter(x => x.name.match(re));
      } else {
        return this.availableMunicipalities;
      }
    },
    filteredUnavailableMunicipalities() {
      let searchInput = this.municipalitySearchInput;
      if (searchInput && this.unavailableMunicipalities) {
        let filteredSearchInput = searchInput.replace(/[^a-zA-Z0-9 |_-]/g, "");
        let re = new RegExp(filteredSearchInput, "i");
        return this.unavailableMunicipalities.filter(x => x.name.match(re));
      } else {
        return this.unavailableMunicipalities;
      }
    }
  },
  mounted() {
    let self = this;

    LoadOrReturnGemeentes().then(function(gemeentes) {
      self.availableMunicipalities = gemeentes.data.filter(
        x => x.payment_status == "paid" || x.payment_status == "trial"
      );
      self.unavailableMunicipalities = gemeentes.data.filter(
        x => x.payment_status != "paid" && !x.payment_status != "trial"
      );
    });
  },
  methods: {
    closeSidebarMunicipalitiesIndex() {
      this.$store.commit("closeSidebarMunicipalitiesIndex");
    },
    openModalNonParticipant(municipality) {
      this.$store.commit("openModalNonParticipant", municipality);
    },
    setActiveMunicipality(municipality, locationSet) {
      if (locationSet) {
        this.setActiveMunicipalityCallback(municipality);
      } else {
        if (municipality.app_asset) {
          let municipalityLatitude = municipality.app_asset.latitude;
          let municipalityLongitude = municipality.app_asset.longitude;
          this.$store.commit("setGpsLatitude", municipalityLatitude);
          this.$store.commit("setGpsLongitude", municipalityLongitude);
          this.setActiveMunicipalityCallback(municipality);
        } else {
          if (!locationSet) {
            let self = this;
            let municipalityName = municipality.name;

            gmapsInit().then(function(google) {
              var geocoder = new google.maps.Geocoder();

              geocoder.geocode({ address: municipalityName }, function(
                results,
                status
              ) {
                if (status === "OK") {
                  let municipalityLatitude = results[0].geometry.location.lat();
                  let municipalityLongitude = results[0].geometry.location.lng();
                  self.$store.commit("setGpsLatitude", municipalityLatitude);
                  self.$store.commit("setGpsLongitude", municipalityLongitude);
                  self.setActiveMunicipalityCallback(municipality);
                }
              });
            });
          }
        }
      }
    },
    setActiveMunicipalityCallback(municipality) {
      this.$store.commit("setActiveMunicipality", municipality);
      this.$store.commit("closeSidebarMunicipalitiesIndex");
      this.$store.commit("openSidebarPositionNew");
      this.$router.push(`/gemeentes/${municipality.id}`);
    },
    positionToMunicipality() {
      let self = this;
      this.gpsLoading = true;

      function success(position) {
        self.$store.commit("setGpsLatitude", position.coords.latitude);
        self.$store.commit("setGpsLongitude", position.coords.longitude);

        PrivateApi()
          .get(
            `gemeentes?search_by_location[latitude]=${
              position.coords.latitude
            }&search_by_location[longitude]=${position.coords.longitude}`
          )
          .then(function(gemeentes) {
            self.setActiveMunicipality(gemeentes.data[0], true);
            if (
              gemeentes.data[0].payment_status != "paid" &&
              !gemeentes.data[0].payment_status != "trial"
            ) {
              self.$store.commit(
                "openModalNonParticipantTwo",
                gemeentes.data[0]
              );
            } else {
              self.$store.commit("closeModalNonParticipantTwo");
            }
            self.gpsLoading = false;
          });
      }

      function error() {
        alert("Verleen alstublieft toestemming om uw locatie te delen");
      }

      navigator.geolocation.getCurrentPosition(success, error);
    }
  }
};
</script>

<style scoped lang="scss">
.sidebar-municipalities-index {
  position: fixed;
  width: 100%;
  max-width: 414px;
  background: $color-gray-2;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  z-index: 3000;
  // height: calc(100% - 52px);

  // &.active {
  //   z-index:3000;
  // }

  &__scrollable {
    flex: 1;
    overflow-y: auto;
    flex-direction: row;
    flex-wrap: wrap;
  }

  &__top {
    height: 52px;
    display: flex;
    align-items: center;
    padding-left: $spacing-3;
  }

  &__middle {
    display: flex;
    background: #fff;
    padding: $spacing-3;
    flex-direction: column;
  }

  &__bottom {
    background: #fff;
    flex: 1;
    padding: 0 $spacing-3 $spacing-3;

    .row {
      flex-wrap: wrap;
      display: flex;
    }
  }

  &__bottom-top {
    display: flex;
    padding: 0 $spacing-3;
    height: 52px;
    border-top: 1px solid $color-gray-1;
    border-bottom: 1px solid $color-gray-1;
  }

  &__down {
    background: #fff;
    flex: 1;
  }

  &__down-top {
    padding: 0 $spacing-3;
    height: 52px;
    border-top: 1px solid $color-gray-1;
    border-bottom: 1px solid $color-gray-1;
  }

  &__title {
    @extend %text-title-1;
  }

  &__subtitle {
    @extend %text-small;
  }

  &__input-container {
  }

  &__search-icon {
  }

  &__location-icon {
  }

  &__small-title {
    @extend %text-small;
    line-height: 52px;
  }

  .row {
    margin-right: -$spacing-3;
    margin-left: -$spacing-3;
  }

  .col {
    float: left;
    padding-right: $spacing-3;
    padding-left: $spacing-3;

    &.col--4 {
      width: 33.33333%;
    }
  }

  .available-column {
    cursor: pointer;
    margin-top: $spacing-3;

    &__image {
    }

    &__fallback {
      position: relative;
      width: 100%;
      padding-top: 100%;
      display: inline-block;
      background: $color-gray-1;
      text-align: center;

      &__text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 30px;
        text-transform: uppercase;
      }
    }

    &__title {
      @extend %text-mini;
      text-align: center;
      word-break: break-word;
    }
  }

  .unavailable-row {
    display: flex;
    align-items: center;
    height: 48px;
    border-bottom: 1px solid $color-gray-1;
    padding: 0 $spacing-3;

    &__left {
    }

    &__right {
      margin-left: auto;
    }

    &__title {
      @extend %text-medium;
    }

    &__button {
      @extend %text-mini;
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
      background-color: $color-green-1;
      color: #ffffff;
      padding: 0 $spacing-3;
      cursor: pointer;
      transition: background-color $easing-1;
      text-transform: uppercase;

      &:hover {
        background-color: darken($color-green-1, 5%);
      }
    }
  }
}

@media (min-width: 768px) {
  .sidebar-municipalities-index {
    &__top {
      padding-left: $spacing-4;
    }
    &__middle {
      padding: $spacing-4;
    }
    &__bottom {
      padding: 0 $spacing-4 $spacing-4 $spacing-4;
    }
    &__bottom-top {
      padding: 0 $spacing-4;
    }
    &__down-top {
      padding: 0 $spacing-4;
    }
    .available-column {
      margin-top: $spacing-4;
    }
    .row {
      margin-right: -$spacing-4;
      margin-left: -$spacing-4;
    }
    .col {
      padding-right: $spacing-4;
      padding-left: $spacing-4;
    }
    .unavailable-row {
      padding: 0 $spacing-4;
    }
  }
}
</style>
